import React from "react";
import _ from "lodash";

const TextInputField = ({
  label,
  value,
  isRequired,
  hasError = false,
  onChange,
  onBlur,
  disabled = false,
  placeholder = "",
  type = "text",
}) => {
  return (
    <div className="field">
      <label className="label is-small">
        {label}
        {isRequired && <span className="has-text-danger">*</span>}
      </label>
      <div className="control">
        <input
          className={`${
            (isRequired && _.isEmpty(value)) || hasError ? "is-danger " : ""
          }input is-small is-radiusless is-expanded`}
          type={type}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
};

export default TextInputField;
